module.exports = __webpack_public_path__ + "img/czs.afdb56e0.png";